export const config =  {
    '3d-model' : { 
        name : "3D Model",

        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['image','name','category','date_uploaded','creator','scaleOfOrigin','polygon_count'],
        type : 'prop',
        columns : [
            { 
                name : "Media",
                key : "image",
                width : "15%",
                type : 'image',
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
             { 
                name : "Category",
                key : "category",
                width : "15%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Sound",
                key : "sound",
                width : "15%",
            },
            { 
                name : "Ring",
                key : "rig",
                width : "15%",
            },
            { 
                name : "Animations",
                key : "animation",
                width : "15%",
            },
            { 
                name : "materials",
                key : "material",
                width : "15%",
            },
            { 
                name : "Interactive Surfaces",
                key : "interactive_surface",
                width : "15%",
            },
            { 
                name : "Polygon Limitaion",
                key : "polygon_limitaion",
                width : "15%",
            },
            { 
                name : "Polygon Count",
                key : "polygon_count",
                // width : "15%",
            },
            { 
                name : "Scale",
                key : "scaleOfOrigin",
                // width : "15%",
            },
            { 
                name : "Dimension",
                key : "dimension",
                width : "15%",
            },
            { 
                name : "Position",
                key : "positionOfOrigin",
                width : "15%",
            },
            { 
                name : "Rotation",
                key : "rotationOfOrigin",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "15%",
            },
            { 
                name : "Scale",
                key : "scale",
                width : "15%",
            },
        ],
        actions : {
            name : "actions",
            width : "30%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="fas fa-tools"></i>',
                    color : "#05D33F",
                    action : 'updateModal'
                },
                {
                    name : "update",
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                          type : "image",
                          hint : "",
                          padding : { x : .7, y : .3},
                          name : "image",
                          accptedFormat : ['png','jpeg', 'jpg'],
                          width : "100%",
                          required : true,
                        //   size : { value : 10, unit : 'KB'},
                        //   error : "image is required",
                          component : "Upload"
                      },
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          required : true,
                        //   maxLength : 3,
                        //   minLength : 2,
                        //   error : "the name should not be empty",
                          name : "name",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
              ],
            },
            {
              group:'center',
              width : '50%',
              elements : [
                    {
                        label : "Categories",
                        placeholder : "Select Category",
                        options_key : "3d-model-categories",
                        name:"category",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Category Types",
                        placeholder : "Select Type",
                        options_key : "category_types",
                        name:"category_type",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    // {
                    //     label : "Other",
                    //     type : "text",
                    //     hint : "other Type",
                    //     padding : { x : .7, y : .3},
                    //     name : "other_type",
                    //     width : "33%",
                    //     component : "Input"
                    // },
                    {
                        label : "Sound",
                        placeholder : "Allowed Sound",
                        options_key : "sounds",
                        name:"sound",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Ring",
                        placeholder : "Type of Rig",
                        options_key : "rings",
                        name:"rig",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        disabled : true,
                        component : "Select"
                    },
                    {
                        label : "Animations",
                        placeholder : "Allowed Animations",
                        options_key : "animations",
                        name:"animation",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        disabled:true,
                        hasPopOver : true,
                        popOver : {
                            title : null,
                            text : 'Animations difnition...'
                        },
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Select Materials",
                        placeholder : "Select Material",
                        options_key : "materials",
                        name:"material",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        disabled : true,
                        component : "Select"
                    },
                    {
                        label : "Interactive Surfaces",
                        placeholder : "Select Interactive Surfaces",
                        options_key : "surfaces",
                        name:"interactive_surface",
                        padding : { x : .7, y : .5},
                        width : "100%",
                        margin : 0,
                        disabled : true,
                        component : "Select"
                    },
                    {
                        label : "Polygon Limitaion",
                        type : "number",
                        hint : "0",
                        value : 0,
                        max : 10000,
                        padding : { x : .7, y : .3},
                        name : "polygon_limitaion",
                        hasPopOver : true,
                        popOver : {
                            title : "Polygon Limitaion",
                            text : 'Polygon Limitaion difnition...'
                        },
                        width : "33%",
                        component : "Input"
                    },
                    {
                        label : "Polygon Count",
                        type : "number",
                        hint : "0",
                        value : 0,
                        padding : { x : .7, y : .3},
                        name : "polygon_count",
                        width : "33%",
                        component : "Input"
                    },
                    {
                        label : "Scale",
                        type : "number",
                        name : "scaleOfOrigin",
                        hint : "0",
                        value : 0,
                        padding : { x : .7, y : .3},
                        name : "scale",
                        width : "33%",
                        component : "Input"
                    },
                    {
                        label : "Dimension",
                        name : "dimension",
                        subText : "in meters",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    text : "Dimension",
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    value : 0,
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    text : " ",
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    value : 0,
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    text : " ",
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    value : 0,
                                    padding : { x : .7, y : .3},
                                    name : "z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Position",
                        name : "positionOfOrigin",
                        subText : "of origin in meters",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Rotation",
                        name : "rotationOfOrigin",
                        subText : "of origin in deg",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                  text : " ",
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                  text : " ",
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                 
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                    {   
                        label : "3D Model",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "fbx",
                        accptedFormat : ['fbx'],
                        width : "100%",
                        // required : true,
                        // error : "this file is required",
                        component : "Upload"
                    },
                    {   
                        label : "IOS Asset Bundle",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "iOS",
                        key : "asset_bundle",
                        width : "100%",
                        // required : true,
                        // error : "this file is required",
                        component : "Upload"
                    },
                    {   
                        label : "Android Asset Bundle",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "Android",
                        key : "asset_bundle",
                        width : "100%",
                        // required : true,
                        // error : "this file is required",
                        component : "Upload"
                    },
                    {   
                        label : "WebGl Asset Bundle",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "WebGL",
                        // required : true,
                        key : "asset_bundle",
                        width : "100%",
                        component : "Upload"
                    },
                    {   
                        label : "GLB",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "glb",
                        width : "100%",
                        accptedFormat : ['glb'],
                        component : "Upload"
                    },
                    {   
                        label : "USDZ",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "usdz",
                        accptedFormat : ['usdz'],
                        width : "100%",
                        component : "Upload"
                    },
                
              ]
            },
          ],
    },
 
    'visual-effect' : { 
        name : "Visual Effect",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['image','name','category','date_uploaded','creator'],
        type : 'effect',
        columns : [
            { 
                name : "Media",
                key : "image",
                width : "20%",
                type : 'image',
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "20%",
            },
            { 
                name : "Prefab Name",
                key : "prefabName",
                width : "20%",
            },
            { 
                name : "Category",
                key : "category",
                width : "20%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Position",
                key : "positionOfOrigin",
                width : "15%",
            },
            { 
                name : "Rotation",
                key : "rotationOfOrigin",
                width : "15%",
            },
            { 
                name : "Scale",
                key : "scaleOfOrigin",
                width : "15%",
            },
            { 
                name : "Duration",
                key : "duration",
                width : "15%",
            },
            { 
                name : "Mouvement Element",
                key : "movementElement",
                width : "15%",
            },
            { 
                name : "Identifiable Surface",
                key : "identifiableSurface",
                width : "15%",
            },
            { 
                name : "Effect Type",
                key : "effectType",
                width : "15%",
            },
            { 
                name : "Allowed Sound",
                key : "allow_sound",
                width : "15%",
            },
            { 
                name : "Loops",
                key : "loops",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "20%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "20%",
            },
        ],
        actions : {
            name : "actions",
            width : "5%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="fas fa-tools"></i>',
                    color : "#05D33F",
                    action : 'updateModal'
                },
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                          label : "image",
                          type : "image",
                          hint : "",
                          padding : { x : .7, y : .3},
                          name : "image",
                          accptedFormat : ['png','jpeg', 'jpg','gif'],
                          required : true,
                        //   error : "image is required",
                          width : "100%",
                          component : "Upload"
                      },
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          name : "name",
                          required : true,
                        //   error : "the name should not be empty",
                          width : "100%",
                          component : "Input"
                      },
                      {
                        label : "Prefab Name",
                        type : "text",
                        hint : "Prefab Name",
                        padding : { x : .7, y : .3},
                        name : "prefabName",
                        required : true,
                      //   error : "the name should not be empty",
                        width : "100%",
                        component : "Input"
                    },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
                  
              ],
            },
            {
              group:'center',
              width : '50%',
              elements : [
                    {
                        label : "Categories",
                        placeholder : "Select Category",
                        options_key :"effects_categories",
                        name:"category",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Category types",
                        placeholder : "Select Category",
                        options_key :"category_types",
                        name:"category_type",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Position",
                        subText : "of origin",
                        name : "positionOfOrigin",
                        type : "group in meters",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : {  metersx : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Y.0 meters",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%.0 meters",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Rotation",
                        name : "rotationOfOrigin",
                        subText : "of origin in deg",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                  text : " ",
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                  text : " ",
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Scale",
                        subText : "of origin",
                        name : "scaleOfOrigin",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Duration ( sec )",
                        type : "number",
                        hint : "0 sec",
                        padding : { x : .7, y : .3},
                        name : "duration",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Mouvement Element",
                        type : "text",
                        hint : "0",
                        padding : { x : .7, y : .2},
                        name : "movementElement",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Identifiable Surface",
                        placeholder : "Select Identifiable Surface",
                        options : [],
                        name:"identifiableSurface",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        disabled:true,
                        component : "Select"
                    },
                    {
                        label : "Effect Type",
                        placeholder : "Select Effect Type",
                        options_key : "effectType",
                        name:"effectType",
                        required : true,
                        // error : "effect type is required",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Allowed Sound",
                        name : "allow_sound",
                        key: 'unique',
                        subText : "",
                        type : "group",
                        width : "50%",
                        group_elements : [
                            {   
                                text : "Yes",
                                padding : { x : .7, y : .3},
                                name : "allow_sound",
                                id : "yes",
                                value : 'yes',
                                checked : true,
                                width : "50%",
                                component : "RadioBtn"
                            },
                            {   
                                text : "No",
                                padding : { x : .7, y : .3},
                                name : "allow_sound",
                                id : "no",
                                value : 'no',
                                width : "50%",
                                component : "RadioBtn"
                            },
                        ]
                    },
                    {   
                        text : "Loops",
                        name : "loops",
                        id : "loops",
                        borderColor : '#82868b',
                        fillColorActive:"#1979E7",
                        fillColor:"#fff",
                        check : false,
                        width : "50%",
                        component : "CheckBox"
                    },
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                {   
                    label : "IOS Asset Bundle",
                    type : "file",
                    key : "asset_bundle",
                    padding : { x : .7, y : .3},
                    name : "iOS",
                    width : "100%",
                    //   error : "this file is required",
                    component : "Upload"
                },
                {   
                    label : "Android Asset Bundle",
                    type : "file",
                    key : "asset_bundle",
                    padding : { x : .7, y : .3},
                    name : "Android",
                    width : "100%",
                    //   error : "this file is required",
                    component : "Upload"
                },
                {   
                    label : "WebGl Asset Bundle",
                    type : "file",
                    key : "asset_bundle",
                    padding : { x : .7, y : .3},
                    name : "WebGL",
                    width : "100%",
                    //   error : "this file is required",
                    component : "Upload"
                }
            
              ]
            },
          ],
    }, 

    'character-model' : { 
        name : "Character Model",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['image','name','category','date_uploaded','creator','scaleOfOrigin','polygon_count'],
        type : 'character_model',
        columns : [
            { 
                name : "Media",
                key : "image",
                width : "15%",
                type : 'image',
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
             { 
                name : "Category",
                key : "category",
                width : "15%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Type Of Rigs",
                key : "rig",
                width : "15%",
            },
            { 
                name : "materials",
                key : "material",
                width : "15%",
            },
            { 
                name : "Interactive Surfaces",
                key : "interactive_surface",
                width : "15%",
            },
            { 
                name : "Polygon Limitaion",
                key : "polygon_limitaion",
                width : "15%",
            },
            { 
                name : "Scale",
                key : "scaleOfOrigin",
                width : "15%",
            },
            { 
                name : "Dimension",
                key : "dimension",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "15%",
            },
            { 
                name : "Scale",
                key : "scale",
                width : "15%",
            },
            { 
                name : "Polygon Count",
                key : "polygon_count",
                width : "15%",
            },
            { 
                name : "Size",
                key : "size",
                width : "15%",
            },
        ],
        actions : {
            name : "actions",
            width : "30%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="fas fa-tools"></i>',
                    color : "#05D33F",
                    action : 'updateModal'
                },
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                          type : "image",
                          hint : "",
                          padding : { x : .7, y : .3},
                          name : "image",
                          accptedFormat : ['png','jpeg', 'jpg'],
                          required : true,
                        //   error : "image is required",
                          width : "100%",
                          component : "Upload"
                      },
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          name : "name",
                          required : true,
                        //   error : "name should not be empty",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                    //   {
                    //     label : "Categories",
                    //     placeholder : "Select Category",
                    //     options_key : "character-model-categories",
                    //     name:"category",
                    //     singleSelect : false,
                    //     padding : { x : .7, y : .5},
                    //     width : "100%",
                    //     margin : 0,
                    //     component : "Select"
                    //     },
             
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
              ],
            },
            {
              group:'center',
              title : "",
              width : '50%',
              elements : [
                    // {
                    //     label : "Type Of Rigs",
                    //     name : "rig",
                    //     subText : "",
                    //     type : "group",
                    //     width : "100%",
                    //     group_elements : [
                    //             {   
                    //                 text : "Humanoid",
                    //                 padding : { x : .7, y : .3},
                    //                 name : "rigs_type",
                    //                 value:"Humanoid",
                    //                 id : "Humanoid",
                    //                 checked : true,
                    //                 width : "50%",
                    //                 component : "RadioBtn"
                    //             },
                    //             {   
                    //                 text : "Custom",
                    //                 padding : { x : .7, y : .3},
                    //                 name : "rigs_type",
                    //                 id : "Custom",
                    //                 value : "Custom",
                    //                 width : "50%",
                    //                 component : "RadioBtn"
                    //             }
                    //     ]
                    // },
                    {
                        label : "Character category",
                        placeholder : "Select Category",
                        options_key : "character_categories",
                        name:"character_category",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "33%",
                        margin : 0,
                        component : "Select"
                        },
                      {
                        label : "Character Type",
                        placeholder : "Select Type",
                        options_key : "character_types",
                        name:"character_type",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "33%",
                        margin : 0,
                        component : "Select"
                        },
                      {
                        label : "character Gender",
                        placeholder : "Select Gender",
                        options_key : "character_gender",
                        name:"character_gender",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "33%",
                        margin : 0,
                        component : "Select"
                        },
              
                    {
                        label : "Select Materials",
                        placeholder : "Select Material",
                        options_key : 'materials',
                        name:"material",
                        disabled : true,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Interactive Surfaces",
                        placeholder : "Select Interactive Surfaces",
                        options_key : 'surfaces',
                        name: "interactive_surface",
                        disabled : true,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Polygon Limitaion",
                        type : "number",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "polygon_count",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Scale",
                        type : "number",
                        name : "scale",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "scale",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Dimension",
                        subText : "in meters",
                        name : "dimension",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                 
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                      {   
                          label : "File Box",
                          type : "file",
                          padding : { x : .7, y : .3},
                          name : "fbx",
                          accptedFormat : ['fbx'],
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "IOS Asset Bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "iOS",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "android_asset_bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "Android",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "WebGl Asset Bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "WebGL",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                        label : "GLB/GLTF",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "glb",
                        width : "100%",
                        accptedFormat : ['glb','gltf'],
                        component : "Upload"
                    },
                      {   
                        label : "USDZ",
                        type : "file",
                        padding : { x : .7, y : .3},
                        name : "usdz",
                        accptedFormat : ['usdz'],
                        width : "100%",
                        component : "Upload"
                    },
              ]
            },
          ],
    },

    'character-animation' : { 
        name : "Character Animation",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['image','name','category','date_uploaded','creator','inverseKinematics'],
        type : 'animation',
        columns : [
            { 
                name : "Media",
                key : "image",
                width : "15%",
                type : 'image',
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
             { 
                name : "Category",
                key : "category",
                width : "15%",
            },
            { 
                name : "Type Of Animation",
                key : "typeOfAnimation",
                width : "15%",
            },
            { 
                name : "Genre",
                key : "genre",
                width : "15%",
            },
            { 
                name : "Trim",
                key : "trim",
                width : "15%",
            },
            { 
                name : "Blend",
                key : "blend",
                width : "15%",
            },
            { 
                name : "Stich",
                key : "stich",
                width : "15%",
            },
            { 
                name : "Spectrum from Mixamo",
                key : "spectrum",
                width : "15%",
            },
            { 
                name : "Rotations",
                key : "rotations",
                width : "15%",
            },
            { 
                name : "Inverse Kinematics",
                key : "inverseKinematics",
                width : "15%",
            },
            { 
                name : "Joints",
                key : "joint",
                width : "15%",
            },
            { 
                name : "Number of loops",
                key : "numberOfLoops",
                width : "15%",
            },
            { 
                name : "Duration",
                key : "duration",
                width : "15%",
            },
            { 
                name : "Type of Rigs",
                key : "rig",
                width : "15%",
            },
            { 
                name : "Position",
                key : "positionOfOrigin",
                width : "15%",
            },
            { 
                name : "Rotation",
                key : "rotationOfOrigin",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "15%",
            },
            { 
                name : "inverse Kinematics",
                key : "inverseKinematics",
                width : "15%",
            },
            { 
                name : "Size",
                key : "size",
                width : "15%",
            },
        ],
        actions : {
            name : "actions",
            width : "30%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="fas fa-tools"></i>',
                    color : "#05D33F",
                    action : 'updateModal'
                },
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                        type : "image",
                        hint : "",
                        padding : { x : .7, y : .3},
                        name : "image",
                        accptedFormat : ['png','jpeg', 'jpg','gif'],
                        width : "100%",
                        component : "Upload"
                      },
                      {
                        label : "Name",
                        type : "text",
                        hint : "Name",
                        padding : { x : .7, y : .3},
                        name : "name",
                        required : true,
                        // error : "name is required",
                        width : "100%",
                        component : "Input"

                      },
                 
                      {
                          label : "Genre",
                          type : "text",
                          hint : "Genre",
                          padding : { x : .7, y : .3},
                          name : "genre",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Trim",
                          type : "text",
                          hint : "Trim",
                          padding : { x : .7, y : .3},
                          name : "trim",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Blend",
                          type : "text",
                          hint : "Blend",
                          padding : { x : .7, y : .3},
                          name : "blend",
                          width : "50%",
                          component : "Input"
                      },
                      {
                          label : "Stich",
                          type : "text",
                          hint : "Stich",
                          padding : { x : .7, y : .3},
                          name : "stich",
                          width : "50%",
                          component : "Input"
                      },
                 
              ],
            },
            {
              group:'center',
              width : '50%',
              elements : [
                {
                    label : "Type Of Animation",
                    placeholder : "Type Of Animation",
                    options_key :"animation_types",
                    // disabled : true,
                    name:"typeOfAnimation",
                    padding : { x : .7, y : .5},
                    width : "33%",
                    margin : 0,
                    component : "Select"
                },
                  {
                    label : "Rig type",
                    placeholder : "Select Rig type",
                    options_key :"rig_types",
                    name:"rig",
                    // singleSelect : false,
                    padding : { x : .7, y : .5},
                    width : "33%",
                    margin : 0,
                    component : "Select"
                    },
                  {
                    label : "category",
                    placeholder : "Select category",
                    options_key :"animation_categories",
                    name:"category",
                    // singleSelect : false,
                    padding : { x : .7, y : .5},
                    width : "33%",
                    margin : 0,
                    component : "Select"
                    },
                    {
                        label : "Spectrum from Mixamo",
                        placeholder : "select Spectrum",
                        options_key : "spectrums",
                        name:"spectrum",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Rotations",
                        placeholder : "Select rotation",
                        options_key : "rotations",
                        name:"rotations",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Inverse Kinematics",
                        placeholder : "Select Inverse Kinematics",
                        options_key : "inverse_kinematics",
                        name:"inverseKinematics",
                        disabled : true,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Joints",
                        type : "number",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "joint",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Number of loops",
                        type : "number",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "numberOfLoops",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Duration ( sec ) ",
                        type : "number",
                        hint : "0 sec",
                        padding : { x : .7, y : .3},
                        name : "duration",
                        width : "50%",
                        component : "Input"
                    },
                    // {
                    //     label : "Type of Rigs",
                    //     // subText : "of origin",
                    //     name :"rig",
                    //     type : "group",
                    //     width : "100%",
                    //     group_elements : [
                    //         {   
                    //             text : "Humanoid",
                    //             padding : { x : .7, y : .3},
                    //             name : "rigs_type",
                    //             id : "Humanoid",
                    //             value : "Humanoid",
                    //             width : "50%",
                    //             component : "RadioBtn"
                    //         },
                    //         {   
                    //             text : "Custom",
                    //             padding : { x : .7, y : .3},
                    //             name : "rigs_type",
                    //             id : "Custom",
                    //             value : "Custom",
                    //             width : "50%",
                    //             component : "RadioBtn"
                    //         },
                    //     ]
                    // },
                    {
                        label : "Position",
                        subText : "of origin",
                        name : "positionOfOrigin",
                        type : "group in meters",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : {  metersx : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Y.0 meters",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%.0 meters",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
         
                    {
                        label : "Rotation",
                        name : "rotationOfOrigin",
                        subText : "of origin in deg",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                 
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                      {   
                          label : "Filmbox",
                          type : "file",
                          padding : { x : .7, y : .3},
                          name : "fbx",
                          accptedFormat : ['fbx'],
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "IOS Asset Bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "iOS",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "Android Asset Bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "Android",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
                      {   
                          label : "WebGl Asset Bundle",
                          type : "file",
                          key : "asset_bundle",
                          padding : { x : .7, y : .3},
                          name : "WebGL",
                          width : "100%",
                        //   error : "this file is required",
                          component : "Upload"
                      },
              ]
            },
          ],
    },

    'voice' : { 
        name : "Voice",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['audio','name','category','date_uploaded','creator'],
        type : 'voice',
        columns : [
            { 
                name : "Media",
                key : "audio",
                width : "15%",
                type : 'audio',
                color : "#5DC3B9",
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "20%",
            },
            { 
                name : "Size",
                key : "size",
                width : "10%",
            },
        ],
        actions : {
            name : "actions",
            width : "5%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="fas fa-tools"></i>',
                    color : "#05D33F",
                    action : 'updateModal'
                },
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '50%',
              elements : [
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          name : "name",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
              ],
            },
            // {
            //   group:'center',
            //   width : '50%',
            //   elements : [
            //         {
            //             label : "Duration ( sec )",
            //             type : "number",
            //             hint : "0",
            //             padding : { x : .7, y : .3},
            //             name : "duration",
            //             width : "50%",
            //             component : "Input"
            //         },
            //         {
            //             label : "Spatial Blend",
            //             type : "text",
            //             hint : "0",
            //             padding : { x : .7, y : .3},
            //             name : "duration",
            //             width : "50%",
            //             component : "Input"
            //         },
            //         {
            //             label : "Voice Type",
            //             placeholder : "Select Sound Type",
            //             options_key : [],
            //             name:"voice_type",
            //             padding : { x : .7, y : .5},
            //             width : "100%",
            //             margin : 0,
            //             component : "Select"
            //         },
                  
            //   ]
            // },
            {
              group:'center',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '50%',
              elements : [
                    {   
                        label : "Upload Voice",
                        type : "audio",
                        padding : { x : .7, y : .3},
                        name : "audio",
                        width : "100%",
                        component : "Upload"
                    },
               
              ]
            },
          ],
       
    },

    'sound' : { 
        name : "Sound",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['audio','name','category','date_uploaded','creator'],
        type : 'sound',
        columns : [
            { 
                name : "Media",
                key : "audio",
                width : "15%",
                type : 'audio',
                color : "#EEBA2E",
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
            { 
                name : "Category",
                key : "category",
                width : "15%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Duration",
                key : "duration",
                width : "15%",
            },
            { 
                name : "Spatial Blend",
                key : "spatialBlend",
                width : "15%",
            },
            { 
                name : "Sound Type",
                key : "soundType",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "20%",
            },
            { 
                name : "Size",
                key : "size",
                width : "10%",
            },
        ],
        actions : {
            name : "actions",
            width : "5%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          name : "name",
                          required : true,
                        //   error : "name should not be empty",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
              ],
            },
            {
              group:'center',
              width : '50%',
              elements : [
                    {
                        label : "Categories",
                        placeholder : "Select Category",
                        options_key :"sound_categories",
                        name:"category",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Category types",
                        placeholder : "Select Category",
                        options_key :"category_types",
                        name:"category_type",
                        // singleSelect : false,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Duration ( sec )",
                        type : "number",
                        hint : "0 sec",
                        padding : { x : .7, y : .3},
                        name : "duration",
                        required : true,
                        // error : "duration is required",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Spatial Blend",
                        type : "text",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "spatialBlend",
                        required : true,
                        // error : "Spatial Blend is required",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Sound Type",
                        placeholder : "Select Sound Type",
                        options_key : "soundType",
                        name:"soundType",
                        // disabled : true,
                        required : true,
                        selected : "3D",
                        // error : "Sound Type is required",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Audio Type",
                        placeholder : "Select Audio Type",
                        options_key : "audioType",
                        name:"audioType",
                        // disabled : true,
                        required : true,
                        selected : "MPEG",
                        // error : "Sound Type is required",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Volume",
                        name:"volume",
                        type: "range",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        value: 0.5,
                        component : "Input"
                    },
                    {
                        label : "Pitch",
                        name: "pitch",
                        type: 'number',
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        value: 1,
                        component : "Input"
                    },
                    {
                        label : "Loop count",
                        name: "loopCount",
                        type: 'number',
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        value: 1,
                        component : "Input"
                    },
                  
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                    {   
                        label : "Upload Audio",
                        type : "audio",
                        padding : { x : .7, y : .3},
                        name : "audio",
                        required : true,
                        // error : "this file is required",
                        width : "100%",
                        component : "Upload"
                    },
               
              ]
            },
          ],
    },

    'video' : { 
        name : "Video",
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['video','name','category','date_uploaded','creator','duration'],
        type : 'video',
        columns : [
            { 
                name : "Media",
                key : "video",
                width : "15%",
                type : 'video',
                // poster : "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/cute-photos-of-cats-cleaning-1593202999.jpg",
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
            { 
                name : "Services",
                key : "service",
                width : "15%",
            },
            { 
                name : "Description",
                key : "description",
                width : "15%",
            },
            { 
                name : "Duration",
                key : "duration",
                width : "15%",
            },
            { 
                name : "Spatial Blend",
                key : "spatial_blend",
                width : "15%",
            },
            { 
                name : "Video Type",
                key : "videoType",
                width : "15%",
            },
            { 
                name : "Sound Type",
                key : "soundType",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "15%",
            },
            // { 
            //     name : "inverse Kinematics",
            //     key : "inverseKinematics",
            //     width : "15%",
            // },
            // { 
            //     name : "Size",
            //     key : "size",
            //     width : "15%",
            // },
        ],
        actions : {
            name : "actions",
            width : "30%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '25%',
              elements : [
                      {
                          label : "Name",
                          type : "text",
                          hint : "Name",
                          padding : { x : .7, y : .3},
                          name : "name",
                          required : true,
                          error:"name should not be empty",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Services ( optional )",
                          type : "text",
                          hint : "services",
                          padding : { x : .7, y : .3},
                          name : "service",
                          width : "100%",
                          component : "Input"
                      },
                      {
                          label : "Description ( optional )",
                          type : "text",
                          multiline : 4,
                          hint : "Description",
                          padding : { x : .7, y : .3},
                          name : "description",
                          width : "100%",
                          component : "Input"
                      },
              ],
            },
            {
              group:'center',
              width : '50%',
              elements : [
                    {
                        label : "Duration ( sec )",
                        type : "number",
                        hint : "0 sec",
                        padding : { x : .7, y : .3},
                        name : "duration",
                        required : true,
                        // error : "duration should not be empty",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Spatial Blend",
                        type : "text",
                        hint : "0",
                        padding : { x : .7, y : .3},
                        name : "duration",
                        required : true,
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Video Type",
                        placeholder : "Select Sound Type",
                        options_key : "videoType",
                        name:"videoType",
                        disabled : true,
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Sound Type",
                        placeholder : "Select Sound Type",
                        options_key : "soundType",
                        disabled : true,
                        name:"soundType",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        margin : 0,
                        component : "Select"
                    },
                  
              ]
            },
            {
              group:'right',
              title : "Attachments",
              icon : '<i class="fas fa-paperclip"></i>',
              width : '25%',
              elements : [
                    {   
                        label : "Upload Video",
                        type : "video",
                        padding : { x : .7, y : .3},
                        name : "video",
                        width : "100%",
                        required : true,
                        // error : "the file is required",
                        component : "Upload"
                    },
               
              ]
            },
          ],
    },

    'images' : { 
        name : "Image",
        accptedFormat : ['png','jpeg', 'jpg'],
        action : "viewStoryDetail",
        hasCheckbox : true,
        border : false,
        default : ['image','name','category','date_uploaded','creator'],
        type : 'overlay',
        columns : [
            { 
                name : "Media",
                key : "image",
                width : "15%",
                type : 'image',
                component : "Media",
            },
            { 
                name : "Name",
                key : "name",
                width : "15%",
            },
             { 
                name : "Category",
                key : "category",
                width : "15%",
            },
            { 
                name : "Description",
                key : "Description",
                width : "15%",
            },
            { 
                name : "Description",
                key : "Description",
                width : "15%",
            },
            { 
                name : "Duration",
                key : "duration",
                width : "15%",
            },
            { 
                name : "Media Height",
                key : "mediaHeight",
                width : "15%",
            },
            { 
                name : "Media width",
                key : "mediaWidth",
                width : "15%",
            },
            { 
                name : "Alignment Type",
                key : "alignmentType",
                width : "15%",
            },
            { 
                name : "Media Type",
                key : "typeOfMedia",
                width : "15%",
            },
            { 
                name : "Image Type",
                key : "typeOfImage",
                width : "15%",
            },
            { 
                name : "Offset Horizontal",
                key : "offsetHorizontal",
                width : "15%",
            },
            { 
                name : "Offset Vertical",
                key : "offsetVertical",
                width : "15%",
            },
            { 
                name : "Position",
                key : "positionOfOrigin",
                width : "15%",
            },
            { 
                name : "Rotation",
                key : "rotationOfOrigin",
                width : "15%",
            },
            { 
                name : "Scale",
                key : "scaleOfOrigin",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "Uploaded Date",
                key :  "date_uploaded",
                width : "15%",
            },
            { 
                name : "uploaded By",
                key : "creator",
                width : "20%",
            },
            // { 
            //     name : "Size",
            //     key : "size",
            //     width : "10%",
            // },
        ],
        actions : {
            name : "actions",
            width : "5%",
            hasToggleList : false,
            hasSimpleList : true,
            elements : [
                {
                    name : 'update',
                    click : "view",
                    icon : '<i class="far fa-edit"></i>',
                    color : "#1979E7",
                    action : 'update'
                },
              
                {
                    name : "",
                    click : "view",
                    icon : '<i class="fas fa-share-alt"></i>',
                    color : "#E28518",
                    action : 'view'
                },
                {
                    name : "delete",
                    click : "view",
                    icon : '<i class="far fa-trash-alt"></i>',
                    color : "#C30B0B",
                    action : 'delete'
                },
            ],
        },
        form : [
            {
              group:"left",
              width : '30%',
              elements : [
                        {
                            type : "image",
                            hint : "",
                            padding : { x : .7, y : .3},
                            name : "image",
                            accptedFormat : ['png','jpeg', 'jpg'],
                            width : "100%",
                            required : true,
                            component : "Upload"
                        },
                        {
                            label : "Media Name",
                            type : "text",
                            hint : "Media Name",
                            padding : { x : .7, y : .3},
                            name : "name",
                            required : true,
                            // error : "the should not be empty",
                            width : "100%",
                            component : "Input"
                        },
                        {
                            label : "Description ( optional )",
                            type : "text",
                            multiline : 4,
                            hint : "Description ( optional )",
                            padding : { x : .7, y : .3},
                            name : "description",
                            width : "100%",
                            component : "Input"
                        },
                        {
                            label : "Duration ( sec )",
                            type : "number",
                            hint : "0 sec",
                            padding : { x : .7, y : .3},
                            name : "duration",
                            width : "100%",
                            component : "Input"
                        },
                        {
                            label : "Media Height",
                            type : "number",
                            hint : "Media Height",
                            padding : { x : .7, y : .3},
                            name : "mediaHeight",
                            width : "50%",
                            component : "Input"
                        },
                        {
                            label : "Media width",
                            type : "number",
                            hint : "Media width",
                            padding : { x : .7, y : .3},
                            name : "mediaWidth",
                            width : "50%",
                            component : "Input"
                        },
              ],
            },
            {
              group:'center',
              width : '70%',
              elements : [
                    {
                        label : "Vertical Alignment",
                        placeholder : "Vertical Alignment",
                        options_key : "verticalAlignment",
                        name:"verticalAlignment",
                        padding : { x : .7, y : .5},
                        width : "25%",
                        selected : "center",
                        margin : 0,
                        component : "Select"
                    },
                    {
                        label : "Horizontal Alignment",
                        placeholder : "Horizontal Alignment",
                        options_key : "horizontalAlignment",
                        name:"horizontalAlignment",
                        padding : { x : .7, y : .5},
                        width : "25%",
                        selected : "center",
                        margin : 0,
                        component : "Select"
                    },
                    // {
                    //     label : "Media Type",
                    //     placeholder : "Media Type",
                    //     options_key : "typeOfMedia",
                    //     name:"typeOfMedia",
                    //     padding : { x : .7, y : .5},
                    //     width : "50%",
                    //     value : "image",
                    //     margin : 0,
                    //     component : "Select"
                    // },
                    {
                        label : "Display Type",
                        placeholder : "Display Type",
                        options_key : "typeOfDisplay",
                        name:"typeOfDisplay",
                        padding : { x : .7, y : .5},
                        width : "50%",
                        selected:"Scene",
                        margin : 0,
                        component : "Select"
                    },
                    {
                      label : "Offset Horizontal",
                      type : "text",
                      hint : "0.0 meters",
                      padding : { x : .7, y : .3},
                      name : "offsetHorizontal",
                      width : "50%",
                      component : "Input"
                    },
                    {
                        label : "Offset Vertical",
                        type : "number",
                        hint : "0.0 meters",
                        padding : { x : .7, y : .3},
                        name : "offsetVertical",
                        width : "50%",
                        component : "Input"
                    },
                    {
                        label : "Position",
                        subText : "of origin",
                        name : "positionOfOrigin",
                        type : "group in meters",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : {  metersx : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Y.0 meters",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 meters",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%.0 meters",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Rotation",
                        name : "rotationOfOrigin",
                        subText : "of Origin in deg",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    text : "Dimension",
                                    label : "X",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0.0 deg",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                    {
                        label : "Position",
                        subText : "of origin",
                        name : "positionOfOrigin",
                        type : "group",
                        width : "100%",
                        group_elements : [
                                {
                                    label : "X",
                                    type : "number",
                                    hint : "0.0",
                                    padding : { x : .7, y : .3},
                                    name : "X",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#EC1E24', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Y",
                                    type : "number",
                                    hint : "0",
                                    padding : { x : .7, y : .3},
                                    name : "Y",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#64BB46', 
                                    borderWidth : 2
                                },
                                {
                                    label : "Z",
                                    type : "number",
                                    hint : "0",
                                    padding : { x : .7, y : .3},
                                    name : "Z",
                                    width : "33%",
                                    component : "Input",
                                    direction : 'row',
                                    value : 0,
                                    borderColor:'#386EB5', 
                                    borderWidth : 2
                                },
                        ]
                    },
                 
              ]
            },
         
          ],
    },
   
}

export const validate = (fields,form) => {
    let errors = {}
    let valid = true
    for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        for (let i = 0; i < element.elements.length; i++) {
            const item = element.elements[i];
            if(item.component == 'Input') {
                if(item.required && (form[item.name]&& form[item.name].trim == '' || !form[item.name] )) valid = false
                else if (item.type == 'text') {
                    if( item.minLength && form[item.name].length < item.minLength ) { valid = false; errors[item.name] = `min length is ${item.minLength}`}
                    else if(item.maxLength && form[item.name].length > item.maxLength ) { valid = false; errors[item.name] = `max length is ${item.maxLength}`}
                }
                else if (item.type == 'number') {
                    if(item.min && parseFloat(form[item.name]) < item.min ) { valid = false; errors[item.name] = `value should be greater than ${item.min}`}
                    else if(item.max && parseFloat(form[item.name]) > item.max ) { valid = false; errors[item.name] = `value  should be less  than ${item.min}`}
                }
                else if (item.type == 'email' && !String(form[item.name]).toLowerCase().match( /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    errors[item.name] = "email is not valid"
                    valid=false
                
                }
                // errors[item.name] = "field should not be empty"
                
            }
            else if(item.component == 'Select' && item.required && (form[item.name] == '' || !form[item.name] )) {
                // errors[item.name] = "field should not be empty"
                valid = false
            }
             else if(item.type == 'image' && item.required && (form[item.name] == '' || !form[item.name] )) {
                 // errors[item.name] = "image is required"
                valid = false
            }
            else if(["video","audio"].includes(item.type) && item.required && (form[item.name] == '' || !form[item.name] )) {
                // errors[item.name] = `${item.type} file is required`
                valid = false
            }
            else if(item.type == 'file' && item.required) {
                if(item.key && (!form[item.key] || form[item.key] && !form[item.key][item.name] || form[item.key][item.name] && !form[item.key][item.name].file)) {
                    // errors[item.name] = "file is required"
                    valid = false
                }
                else if (!item.key && (!form[item.name] || form[item.name] && !form[item.name].file) ) {
                    // errors[item.name] = "file is required"
                    valid = false
                    
                }
            }
            // if(item.type == 'group' && item.required && (form[item.name] == '' || !form[item.name] )) {
            //     errors[item.name] = "field should not be empty"
            //     valid = false
            // }
            
        }
    }
    return {isValid:valid, errors : errors}
}

export const modalConfig = {
        'character-animation' : [
            {
                label : "character Model",
                placeholder : "Select character Model",
                options_key : "character_models",
                name:"character_model",
                padding : { x : .7, y : .5},
                hasImage : true,
                returnType : 'object',
                width : "100%",
                margin : 0,
                component : "Select"
            },
        ],
        voice : [
            {
                label : "Voice Type",
                placeholder : "Select Voice Type",
                name:"voiceGender",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                disabled : true,
                component : "Input"
            },
            {
                label : "Language",
                disabled : true,
                placeholder : "input Language",
                name:"voiceLanguage",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                disabled : true,
                component : "Input"
            },
            {
                label : "Voice Effect",
                placeholder : "Select Voice Effect",
                name:"voiceEffect",
                padding : { x : .7, y : .5},
                disabled : true,
                width : "100%",
                margin : 0,
                component : "Input"
            },
            {
                label : "Voice Text",
                placeholder : "Voice Text",
                name:"text",
                padding : { x : .7, y : .5},
                width : "100%",
                component : "Input"
            },
        ],
        'visual-effect' : [
            {
                label : "character Model",
                placeholder : "Select character Model",
                options_key : "character_models",
                name:"character_model",
                hasImage : true,
                returnType : 'object',
                padding : { x : .7, y : .5},
                width : "100%",
                margin : 0,
                component : "Select"
            },
        ],
        "3d-model" : [
            {
                label : "Environment Image",
                placeholder : "Select Environment Image",
                options_key : "environment_image",
                name:"environment",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Select"
            },
            {
                label : "Animations",
                placeholder : "Select Animations",
                options_key : "modal_animations",
                name:"animation",
                padding : { x : .7, y : .5},
                width : "50%",
                selected : null,
                margin : 0,
                disabled: true,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Effects",
                placeholder : "Select Effects",
                options_key : "modal_effects",
                name:"effect",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Voice",
                placeholder : "Select Voice",
                options_key : "modal_voices",
                name:"voice",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Voice Text",
                placeholder : "Voice Text",
                hint : "Voice Text",
                name:"voice_text",
                padding : { x : .7, y : .5},
                width : "100%",
                component : "Input"
            },
            {
                label : "Exposure",
                name:"exposure",
                max : 2,
                min  :0,
                step : 0.01,
                value : 1,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Exposure",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Exposure",
                padding : { x : .7, y : .3},
                name : "exposure",
                width : "50%",
                component : "Input"
            },
            {
                label : "Shadow Intensity",
                name:"shadow_intensity",
                max : 2,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Shadow Intensity",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Shadow Intensity",
                padding : { x : .7, y : .3},
                name : "shadow_intensity",
                width : "50%",
                component : "Input"
            },
            {
                label : "Shadow Softness",
                name:"shadow_softness",
                max : 2,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Shadow Softness",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Shadow Softness",
                padding : { x : .7, y : .3},
                name : "shadow_softness",
                width : "50%",
                component : "Input"
            },
            {
                label : "Scale",
                name:"scale",
                max : 1,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Scale",
                type : "number",
                max : 1,
                min  :0,
                value : 1,
                hint : "Scale",
                padding : { x : .7, y : .3},
                name : "scale",
                width : "50%",
                component : "Input"
            },
            {
                label : "Select Material",
                placeholder : "Select Material",
                options_key : "modal_material",
                name:"modal_material",
                // disabled :true,
                padding : { x : .7, y : .5},
                width : "100%",
                margin : 0,
                component : "Select"
            },
            {
                label : "Factor",
                name:"factor",
                id:"factor",
                width : "100%",
                margin : 0,
                component : "ColorPicker"
            },
            {
                label : "Texture",
                name:"texture",
                id:"texture",
                width : "100%",
                margin : 0,
                component : "TexturePicker"
            },
        ],
        'character-model' : [
            {
                label : "Environment Image",
                placeholder : "Select Environment Image",
                options_key : "environment_image",
                name:"environment",
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Select"
            },
            {
                label : "Animations",
                placeholder : "Select Animations",
                options_key : "modal_animations",
                name:"animation",
                padding : { x : .7, y : .5},
                width : "50%",
                selected : null,
                withDefaultVal : false,
                margin : 0,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Effects",
                placeholder : "Select Effects",
                options_key : "modal_effects",
                name:"effect",
                withDefaultVal : false,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Voice",
                placeholder : "Select Voice",
                options_key : "modal_voices",
                name:"voice",
                withDefaultVal : false,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                returnType : 'object',
                component : "Select"
            },
            {
                label : "Voice Text",
                placeholder : "Voice Text",
                name:"voice_text",
                padding : { x : .7, y : .5},
                width : "100%",
                component : "Input"
            },
            {
                label : "Exposure",
                name:"exposure",
                max : 2,
                min  :0,
                step : 0.01,
                value : 1,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Exposure",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Exposure",
                padding : { x : .7, y : .3},
                name : "exposure",
                width : "50%",
                component : "Input"
            },
            {
                label : "Shadow Intensity",
                name:"shadow_intensity",
                max : 2,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Shadow Intensity",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Shadow Intensity",
                padding : { x : .7, y : .3},
                name : "shadow_intensity",
                width : "50%",
                component : "Input"
            },
            {
                label : "Shadow Softness",
                name:"shadow_softness",
                max : 2,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Shadow Softness",
                type : "number",
                max : 2,
                min  :0,
                value : 1,
                hint : "Shadow Softness",
                padding : { x : .7, y : .3},
                name : "shadow_softness",
                width : "50%",
                component : "Input"
            },
            {
                label : "Scale",
                name:"scale",
                max : 1,
                min  :0,
                step : 0.01,
                padding : { x : .7, y : .5},
                width : "50%",
                margin : 0,
                component : "Range"
            },
            {
                label : "Scale",
                type : "number",
                max : 1,
                min  :0,
                value : 1,
                hint : "Scale",
                padding : { x : .7, y : .3},
                name : "scale",
                width : "50%",
                component : "Input"
            },
            {
                label : "Select Material",
                placeholder : "Select Material",
                options_key : "modal_material",
                name:"modal_material",
                // disabled :true,
                padding : { x : .7, y : .5},
                width : "100%",
                margin : 0,
                component : "Select"
            },
            {
                label : "Factor",
                name:"factor",
                id:"factor",
                width : "100%",
                margin : 0,
                component : "ColorPicker"
            },
            {
                label : "Texture",
                name:"texture",
                id:"texture",
                width : "100%",
                margin : 0,
                component : "TexturePicker"
            },
        ]
}

export const categories = {
    '3d-model': {
        "Furniture" : ['chair','Sofa','table'],
        "Electronics &gadgets" : ['Tv', 'radio', 'Fridge'],
        "tabletop" : [],
        "nature & plants" : [],
        "books" : [],
        "architecture" : [],
        "cars & bicyles" : [],
        "Food" : [],
        "shapes" : [],
        "Signs" : [],
        "other" : [],
    },
    'visual-effect': {
        "3D" : ['Environment(rain snow,fire,etc)','SciFi','Magic','other'],
        "2D" : [],
    },
    'sound': {
        "Music" : ['Happy','Calm','Jazz','HipHop'],
        "Effects" : ['Human(laugh, applaus )','Nature','Animal Sounds'],
    }
}


// WEBPACK FOOTER //
// ./src/views/assets/config.js